// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Services from './Services';
import {getServices} from "../../../redux/stores/services";

export default compose(
  connect(
    state => ({
      services: state.services.services,
      isLoading: state.services.isLoadingServices,
    }),
    dispatch => ({
      getServices: () => dispatch(getServices()),
    }),
  ),
)(Services);
